export default (date, format = 'YYYY-MM-DD hh:mm:ss') => {
  if (+date === 0 || isNaN(+date)) {
    console.error(`invalid date: ${date}`)
    return date
  }

  let d = new Date(+date)
  let year = d.getFullYear()
  let month = d.getMonth() + 1
  let day = d.getDate()
  let hour = d.getHours()
  let min = d.getMinutes()
  let sec = d.getSeconds()

  function pad(num) {
    return String(num).replace(/\b(\d)\b/g, '0$1')
  }

  return format.replace('YYYY', year)
    .replace(/MM/, pad(month))
    .replace(/\b(M)\b/, month)

    .replace(/DD/, pad(day))
    .replace(/\b(D)\b/, day)

    .replace(/hh/, pad(hour))
    .replace(/\b(h)\b/, hour)

    .replace(/mm/, pad(min))
    .replace(/\b(m)\b/, min)

    .replace(/ss/, pad(sec))
    .replace(/\b(s)\b/, sec)
}
